/**
 * @module app.ae
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { AutomationEngineModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(AutomationEngineModule.registrationKey, AutomationEngineModule);

    config.globalResources([
        // elements

        // elements/members

        // elements/providers

        // value-converters
    ]);
}
